import { action, noop } from '@reatom/framework'

export const clearDataRequestedEvent = action(noop, 'clearDataRequestedEvent')
